import React from 'react';
import * as Styles from './styles';
import { Text } from '../../../Text';
import { Car } from '@olxbr/ds-spots';
import Container from '../../../Container';
/**
 * Componente Banner do Design System OLX
 */
export const Banner = () => React.createElement(Styles.BannerWrapper, {
  "data-ds-component": "DS-Banner-Menu"
}, React.createElement(Container, {
  type: "elevated",
  padding: "--spacing-2"
}, React.createElement(Styles.Content, null, React.createElement(Text.BodySmall, {
  weight: "bold"
}, "Consulte a Tabela Fipe OLX"), React.createElement(Text.BodySmall, null, "Confira aqui o pre\u00E7o do modelo que est\u00E1 procurando.")), React.createElement(Car, {
  size: 64
})));
Banner.displayName = 'Banner';